import { render } from "./Home.vue?vue&type=template&id=39554fd4&ts=true"
import script from "./Home.ts?vue&type=script&lang=ts"
export * from "./Home.ts?vue&type=script&lang=ts"

import exportComponent from "/Users/office/Library/CloudStorage/Dropbox/Works/LINEMP3/www-linemp3-com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__